export const colors = {
  DARK_BLUE: '#06233D',
  RED: '#EA555F',
  WHITE: '#ffffff',
  GREEN: '#009081',
  GREY: '#e9ebee',
  GREY_TEXT: '#CFCFCF',
  BACKGROUND: '#E5F3F2',
  DARK_GRAY: '#BFCCD8',
  ORANGE: '#F4A261',
  BLUE: '#2A7DBC',
  PURPLE: '#A020F0',
  LIGHT_BLUE: '#44BBD8',
  VIOLET: '#703CE5'
};

export const fontWeight = {
  NORMAL: 400,
  MEDIUM: 500,
  SEMI_BOLD: 600,
  BOLD: 700
};

export const LANGUAGE_CODES = [
  'af',
  'ar-ae',
  'ar-bh',
  'ar-dz',
  'ar-eg',
  'ar-iq',
  'ar-jo',
  'ar-kw',
  'ar-lb',
  'ar-ly',
  'ar-ma',
  'ar-om',
  'ar-qa',
  'ar-sa',
  'ar-sy',
  'ar-tn',
  'ar-ye',
  'be',
  'bg',
  'ca',
  'cs',
  'cy',
  'da',
  'de',
  'de-at',
  'de-ch',
  'de-li',
  'de-lu',
  'el',
  'en',
  'en-au',
  'en-bz',
  'en-ca',
  'en-gb',
  'en-ie',
  'en-jm',
  'en-nz',
  'en-tt',
  'en-us',
  'en-za',
  'es',
  'es-ar',
  'es-bo',
  'es-cl',
  'es-co',
  'es-cr',
  'es-do',
  'es-ec',
  'es-gt',
  'es-hn',
  'es-mx',
  'es-ni',
  'es-pa',
  'es-pe',
  'es-pr',
  'es-py',
  'es-sv',
  'es-uy',
  'es-ve',
  'et',
  'eu',
  'fa',
  'fi',
  'fo',
  'fr',
  'fr-be',
  'fr-ca',
  'fr-ch',
  'fr-lu',
  'ga',
  'gd',
  'he',
  'hi',
  'hr',
  'hu',
  'id',
  'is',
  'it',
  'it-ch',
  'ja',
  'ji',
  'ko',
  'ku',
  'lt',
  'lv',
  'mk',
  'ml',
  'ms',
  'mt',
  'nb',
  'nl',
  'nl-be',
  'nn',
  'no',
  'pa',
  'pl',
  'pt',
  'pt-br',
  'rm',
  'ro',
  'ro-md',
  'ru',
  'ru-md',
  'sb',
  'sk',
  'sl',
  'sq',
  'sr',
  'sv',
  'sv-fi',
  'th',
  'tn',
  'tr',
  'ts',
  'ua',
  'ur',
  've',
  'vi',
  'xh',
  'zh-cn',
  'zh-hk',
  'zh-sg',
  'zh-tw',
  'zu'
];

export const MODALS = {
  HIDE_FLOWS_WELCOME_MODAL: 'hideFlowsWelcomeModal',
  HIDE_AUTOGEN_MODAL: 'hideAutogenModal'
};

export const OPENAPI_ACCEPTED_FILE_TYPES: string[] = ['json', 'yml', 'yaml'];
export const OPENAPI_ALLOWED_FILE_SIZE_IN_MB = 2;

export const openApiErrorMsg = {
  invalidFileType:
    'Invalid file type. Only .json, .yml and .yaml files are accepted.',
  checkOpenAPIVersion: 'Kindly check your OpenAPI version.',
  requiredServerObjects: 'The servers object is required.',
  pathAndOperationsRequired: 'Available paths and operations are required.',
  processingError: "Sorry, we're unable to process the uploaded file.",
  createConnectorError:
    "Sorry, we're unable to create your connector. Please try again later.",
  openAPIReq:
    'Kindly upload an OpenAPI file or provide a valid OpenAPI specification document link.',
  fileTooLarge: 'File size must be less than 2MB.'
};

export const OutcomeText = {
  SUCCESS: 'Success. Your request has been seen before',
  SIMILAR:
    'Your request is similar to one that has been seen before and new training has been added to existing flow',
  AMBIGUOUS: 'The request was too vague to be understood',
  OUT_OF_SCOPE:
    'The request was out of scope and not relevant to your AI assistant',
  NEW_FLOW: 'Your request is a new one and a new flow has been created',
  NO_OUTCOME: 'No action taken'
};

export const SCREEN_WIDTH = {
  TABLET: 1024,
  SMALL: 800,
  MOBILE: 480
};

export const BannerState = {
  UNREAD: 'unread',
  READ: 'read',
  DISMISSED: 'dismissed'
};

export const FONT_FAMILY = `Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'`;

export const MAX_INSTRUCTIONS_LENGTH = 10000;

export const OPENAI_MODELS = {
  GPT_5: 'gpt-5',
  GPT_5_MINI: 'gpt-5-mini',
  GPT_5_4_MINI: 'gpt-5.4-mini',
  GPT_5_5: 'gpt-5.5',
  GPT_6_LUNA: 'gpt-6-luna',
  GPT_6_1_SOL: 'gpt-6.1-sol',
  GPT_5_1: 'gpt-5.1',
  GPT_5_2: 'gpt-5.2',
  GPT_4_1: 'gpt-4.1'
};

export const OPENAI_MODEL_LABELS = {
  [OPENAI_MODELS.GPT_6_LUNA]: 'Fast',
  [OPENAI_MODELS.GPT_6_1_SOL]: 'Extra thinking but slower',
  [OPENAI_MODELS.GPT_5_4_MINI]: 'Fast',
  [OPENAI_MODELS.GPT_5_5]: 'Extra thinking but slower',
  [OPENAI_MODELS.GPT_5_2]: 'GPT-5.2',
  [OPENAI_MODELS.GPT_5_1]: 'GPT-5.1',
  [OPENAI_MODELS.GPT_5_MINI]: 'GPT-5-mini',
  [OPENAI_MODELS.GPT_5]: 'GPT-5',
  [OPENAI_MODELS.GPT_4_1]: 'GPT-4.1'
};

export const OPENAI_SELECTABLE_MODEL_OPTIONS = [
  {
    label: OPENAI_MODEL_LABELS[OPENAI_MODELS.GPT_6_LUNA],
    value: OPENAI_MODELS.GPT_6_LUNA
  },
  {
    label: OPENAI_MODEL_LABELS[OPENAI_MODELS.GPT_6_1_SOL],
    value: OPENAI_MODELS.GPT_6_1_SOL
  }
];

export type OpenAIModelOption = {
  label: string;
  value: string;
  disabled?: boolean;
  className?: string;
};

export const getOpenAIModelOptions = (
  selectedModel?: string | null
): OpenAIModelOption[] => {
  const resolvedSelectedModel = selectedModel ?? DEFAULT_MODEL;
  const selectedModelLabel =
    OPENAI_MODEL_LABELS[
      resolvedSelectedModel as keyof typeof OPENAI_MODEL_LABELS
    ];
  const isLegacySelectedModel =
    Boolean(selectedModelLabel) &&
    !OPENAI_SELECTABLE_MODEL_OPTIONS.some(
      option => option.value === resolvedSelectedModel
    );

  return [
    ...OPENAI_SELECTABLE_MODEL_OPTIONS,
    ...(isLegacySelectedModel
      ? [
          {
            label: selectedModelLabel,
            value: resolvedSelectedModel,
            disabled: true,
            className: 'legacy-model-option'
          }
        ]
      : [])
  ];
};

export const OPENAI_REASONING_MODELS = [
  OPENAI_MODELS.GPT_5,
  OPENAI_MODELS.GPT_5_MINI,
  OPENAI_MODELS.GPT_5_4_MINI,
  OPENAI_MODELS.GPT_5_5,
  OPENAI_MODELS.GPT_6_LUNA,
  OPENAI_MODELS.GPT_6_1_SOL,
  OPENAI_MODELS.GPT_5_1,
  OPENAI_MODELS.GPT_5_2
];

export const OPENAI_REASONING_EFFORT_OPTIONS = {
  [OPENAI_MODELS.GPT_5]: ['low', 'medium', 'high'],
  [OPENAI_MODELS.GPT_5_MINI]: ['minimal', 'low', 'medium', 'high'],
  [OPENAI_MODELS.GPT_5_4_MINI]: ['none', 'low', 'medium', 'high', 'xhigh'],
  [OPENAI_MODELS.GPT_5_5]: ['none', 'low', 'medium', 'high', 'xhigh'],
  [OPENAI_MODELS.GPT_6_LUNA]: ['none', 'low', 'medium', 'high', 'xhigh'],
  [OPENAI_MODELS.GPT_6_1_SOL]: ['low', 'medium', 'high', 'xhigh'],
  [OPENAI_MODELS.GPT_5_1]: ['none', 'low', 'medium', 'high'],
  [OPENAI_MODELS.GPT_5_2]: ['none', 'low', 'medium', 'high', 'xhigh']
};

/**
 * Models that support sampling parameters (temperature, top_p, logprobs)
 * ONLY when reasoning_effort is set to 'none'.
 * Per OpenAI docs: https://platform.openai.com/docs/guides/latest-model#migration-guidance
 */
export const OPENAI_MODELS_SAMPLING_WITH_NONE_ONLY = [
  OPENAI_MODELS.GPT_5_2,
  OPENAI_MODELS.GPT_5_1,
  OPENAI_MODELS.GPT_6_LUNA
];

/**
 * Models that NEVER support sampling parameters (temperature, top_p, logprobs)
 * regardless of reasoning effort setting.
 * Per OpenAI docs: https://platform.openai.com/docs/guides/latest-model#migration-guidance
 */
export const OPENAI_MODELS_NO_SAMPLING_SUPPORT = [
  OPENAI_MODELS.GPT_5,
  OPENAI_MODELS.GPT_5_MINI,
  OPENAI_MODELS.GPT_5_4_MINI,
  OPENAI_MODELS.GPT_5_5,
  OPENAI_MODELS.GPT_6_1_SOL
];

export const DEFAULT_MODEL = OPENAI_MODELS.GPT_6_LUNA;

export const getDefaultReasoningEffort = (model: string): 'none' | 'low' =>
  [
    OPENAI_MODELS.GPT_5_1,
    OPENAI_MODELS.GPT_5_2,
    OPENAI_MODELS.GPT_5_5
  ].includes(model)
    ? 'none'
    : 'low';
